import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

export default createStore({
  state: {
    loginInfo: {
      login_id: "",
      name: "",
      pic_head: "",
      fendian_id: "",
      dept_name: "",
      role_id: "",
      fendian_name: "",
      qianming: "",
      saas_dead_datetime: "",
      role_name: "",
      dept_id: "",
      bingqu_id: "",
      bingqu_name: "",
      menzhen_cls_name: "",
      menzhen_cls_id: "",
    },
    BaseUrl: "",
    ecomBaseUrl: "",
    uploadToken: "",
    yuyue_url: "https://pay.ecom20201123.com",
    yuYueUrl: "https://pay.ecom20201123.com",
    dropdownData: {}, //下拉列表数据
    patient_pid: 0,
    ybUser: "", // 新医保网点编号
    ybPwd: "", // 医保网点编号密码
    yb_feedetl_sn: 10000000, // 医保费用明细流水号
    ybStatus: 0, //账号是否启用医保
    ybAddressNum: "", // 就医地医保区划
    insuplc_admdvs: "", // 参保地医保区划
    ybInfo: {
      // 电子医保扫码数据
      electronicYbData: {},
      // 医保实体卡数据
      ybCardData: {},
      // 结算方式 1:电子医保卡 2.刷医保实体卡 3.自费
      settlementPay: 3,
      data1101: {},
      data2401: {},
      data2301: {},
      data2303: {},
      data2304: {},
      data2305: {},
    },
    // 门诊数据
    patHistoryZhenduan: true,
    doc_id: "", // 当前选择挂号医生
    patInfo: {
      id: "",
      pid: "",
      guahao_id: "",
      yuyue_id: "",
      guahao_datetime: "",
      guahao_dor_id: "",
    },
    pathAlias: [],
    allPrescription: {},
    currentChufangNo: "", // 当前复制的处方号
    currentPatPid: "", // 病人档案pid
    currentIpNo: "",
    patBaseInfo: {
      pat_name: "",
      pat_tel: "",
      pat_sex: "未知",
      pat_age: 0,
    },
    curEditorPatInfo: {}, // 当前电子编辑器选择病人信息
    editorTempType: 1, // 1：门诊病历 2：收费小票 3：处方草药格式 4：处方西药 5：处方治疗 6：处方颗粒
    updateNotice: 0,
    startupLoginYb: false,
  },
  getters: {
    isStartLoginYb: (state) => {
      return state.startupLoginYb
    },
    BaseUrl: (state) => {
      return state.BaseUrl;
    },
    loginId: (state) => {
      return state.loginInfo.login_id;
    },
    userName: (state) => {
      return state.loginInfo.name;
    },
    fendianId: (state) => {
      return state.loginInfo.fendian_id;
    },
    deptName: (state) => {
      return state.loginInfo.dept_name;
    },
    roleId: (state) => {
      return state.loginInfo.role_id;
    },
    uploadToken: (state) => {
      return state.uploadToken;
    },
    dropdownData: (state) => {
      return state.dropdownData;
    },
    patientPid: (state) => {
      return state.patient_pid;
    },
    yuyueId: (state) => {
      return state.patInfo.yuyue_id || state.patInfo.id;
    },
    patId: (state) => {
      return state.patInfo.pid;
    },
    currentPatPid: (state) => {
      return state.currentPatPid;
    },
    patBaseInfo: (state) => {
      return state.patBaseInfo;
    },
    pathAlias: (state) => {
      return state.pathAlias;
    },
  },
  mutations: {
    SET_START_LOGIN_YB: (state, data) => {
      state.startupLoginYb = data;
    },
    SET_BaseUrl: (state, data) => {
      state.BaseUrl = data;
    },
    SET_EcomBaseUrl: (state, data) => {
      state.ecomBaseUrl = data;
    },
    SET_LOGIN_INFO: (state, data) => {
      state.loginInfo = data;
    },
    SET_PIC_HEAD: (state, data) => {
      state.loginInfo.pic_head = data;
    },
    INIT_STATE: (state) => {
      localStorage.removeItem("token");
      localStorage.removeItem("loginInfo");
      state.loginInfo = {
        login_id: "",
        name: "",
        pic_head: "",
        fendian_id: "",
        dept_name: "",
        role_id: "",
        fendian_name: "",
        qianming: "",
        saas_dead_datetime: "",
        role_name: "",
        dept_id: "",
        bingqu_id: "",
        bingqu_name: "",
        menzhen_cls_name: "",
        menzhen_cls_id: "",
      };
      state.patInfo = {
        id: "",
        pid: "",
        guahao_id: "",
        yuyue_id: "",
        guahao_datetime: "",
        guahao_dor_id: "",
      };
      state.patBaseInfo = {
        pat_name: "",
        pat_tel: "",
        pat_sex: "未知",
        pat_age: 0,
      };
      state.doc_id = "";
    },
    SET_UPLOADTOKEN_DATA: (state, data) => {
      state.uploadToken = data;
    },
    SET_DROPDOWN_DATA: (state, data) => {
      Object.assign(state.dropdownData, data);
      // state.dropdownData = data;
    },
    SET_USER_NAME: (state, data) => {
      Object.assign(state.loginInfo, data);

      // state.loginInfo.name = data;
    },
    SET_PATIENT_PID: (state, data) => {
      state.patient_pid = data;
    },
    SETYBSTATUS: (state, data) => {
      state.ybStatus = data;
    },
    SETYBUSER: (state, data) => {
      state.ybUser = data;
    },
    SETYBPDW: (state, data) => {
      state.ybPwd = data;
    },
    SETYBADDRESSNUM: (state, data) => {
      state.ybAddressNum = data;
    },
    SETINSUPLCADMDVS: (state, data) => {
      state.insuplc_admdvs = data;
    },
    SETELEYBDATA: (state, data) => {
      state.ybInfo.electronicYbData = data;
    },
    SETYBINFO1101: (state, data) => {
        state.ybInfo.data1101 = data;
    },
    SETYBINFO2401: (state, data) => {
        state.ybInfo.data2401 = data;
    },
    SETYBINFO2301: (state, data) => {
        state.ybInfo.data2301 = data;
    },
    SETYBINFO2303: (state, data) => {
        state.ybInfo.data2303 = data;
    },
    SETYBINFO2304: (state, data) => {
        state.ybInfo.data2304 = data;
    },
    SETYBINFO2305: (state, data) => {
      state.ybInfo.data2305 = data;
    },
    SETCARDYBDATA: (state, data) => {
      state.ybInfo.ybCardData = data;
    },
    SETSETTLEMENTPAY: (state, data) => {
      state.ybInfo.settlementPay = data;
    },
    SET_PRESCRIPTION: (state: any, data: any) => {
      // const key: any = state.patInfo.id || state.patInfo.yuyue_id;
      const key: any = state.currentIpNo;
      state.allPrescription[key] = data;
    },
    SET_CURRENT_PAT_PID: (state, data) => {
      state.currentPatPid = data;
    },
    SETCURRENTCHUFANGNO: (state, data) => {
      state.currentChufangNo = data;
    },
    SETTLEMENT: (state) => {
      state.patInfo = {
        id: "",
        pid: "",
        guahao_id: "",
        yuyue_id: "",
        guahao_datetime: "",
        guahao_dor_id: "",
      }
      state.patBaseInfo = {
        pat_name: "",
        pat_tel: "",
        pat_sex: "未知",
        pat_age: 0,
      }
      state.dropdownData = {};
      state.doc_id = "";
      state.uploadToken = "";
    },
    SET_REMOVE_ITEM_PRESCRIPTION: (state: any, data) => {
      // 清空某个处方药品
      delete state.allPrescription[data];
    },
    SET_PAT_INFO: (state, data) => {
      state.patInfo = data;
    },
    SET_PAT_BASEINFO: (state, data) => {
      state.patBaseInfo = data;
    },
    SETCUREDITORPATINFO: (state, data) => {
      state.curEditorPatInfo = data;
    },
    SETEDITORTEMPTYPE: (state, data) => {
      state.editorTempType = data;
    },
    SET_CURRENT_IP_NO: (state, data) => {
      state.currentIpNo = data;
    },
    SET_PATH_ALIAS: (state, data) => {
      state.pathAlias = data;
    },
    SET_UPDATE_NOTICE: (state, data) => {
      state.updateNotice = data;
    },
  },
  actions: {
    setStartLoginYb({ commit }, data) {
        commit("SET_START_LOGIN_YB", data);
    },
    setLoginInfo({ commit }, data) {
      commit("SET_LOGIN_INFO", data);
    },
    setPicHead({ commit }, data) {
      commit("SET_PIC_HEAD", data);
    },
    clearInfo({ commit }) {
      commit("INIT_STATE");
    },
    setUploadToken({ commit }, data) {
      commit("SET_UPLOADTOKEN_DATA", data);
    },
    setDropdownData({ commit }, data) {
      commit("SET_DROPDOWN_DATA", data);
    },
    setUserName({ commit }, data) {
      commit("SET_USER_NAME", data);
    },
    setPatientPid({ commit }, data) {
      commit("SET_PATIENT_PID", data);
    },
    setYbStatus({ commit }, data) {
      commit("SETYBSTATUS", data);
    },
    setYbUser({ commit }, data) {
      commit("SETYBUSER", data);
    },
    setYbPdw({ commit }, data) {
      commit("SETYBPDW", data);
    },
    setYbAddressNum({ commit }, data) {
      commit("SETYBADDRESSNUM", data);
    },
    setInsuplcAdmdvs({ commit }, data) {
      commit("SETINSUPLCADMDVS", data);
    },
    setYbInfo({ commit }, data) {
      const { electronicYbData, ybCardData, settlementPay } = data || {}
      commit("SETELEYBDATA", electronicYbData || {});
      commit("SETCARDYBDATA", ybCardData || {});
      commit("SETSETTLEMENTPAY", settlementPay || 3);
    },
    setInitYbInfo({ commit }, data) {
        commit("SETELEYBDATA", {})
        commit("SETYBINFO1101", {})
        commit("SETYBINFO2401", {})
        commit("SETYBINFO2301", {})
        commit("SETYBINFO2303", {})
        commit("SETYBINFO2304", {})
        commit("SETYBINFO2305", {})
        commit("SETCARDYBDATA", {})
        commit("SETSETTLEMENTPAY", 3)
    },
    setYbDetail({ commit }, data) {
        const { type, detail } = data
        if (type === 1101) {
            commit("SETYBINFO1101",detail)
        }
        if (type === 2401) {
            commit("SETYBINFO2401",detail)
        }
        if (type === 2301) {
            commit("SETYBINFO2301",detail)
        }
        if (type === 2303) {
            commit("SETYBINFO2303",detail)
        }
        if (type === 2304) {
            commit("SETYBINFO2304",detail)
        }
        if (type === 2305) {
            commit("SETYBINFO2305",detail)
        }
    },
    setPrescription({ commit }, data) {
      commit("SET_PRESCRIPTION", data);
    },
    setCurrentPatPid({ commit }, data) {
      commit("SET_CURRENT_PAT_PID", data);
    },
    setCurrentChufangNo({ commit }, data) {
      commit("SETCURRENTCHUFANGNO", data);
    },
    settlement({ commit }, data) {
      // 结算成功后调用
      commit("SETTLEMENT");
    },
    setRemoveItemPrescription({ commit }, data) {
      commit("SET_REMOVE_ITEM_PRESCRIPTION", data);
    },
    setPatInfo({ commit }, data) {
      commit("SET_PAT_INFO", data);
    },
    setPatBaseInfo({ commit }, data) {
      commit("SET_PAT_BASEINFO", data);
    },
    setCurEditorPatInfo({ commit }, data) {
      commit("SETCUREDITORPATINFO", data);
    },
    setEditorTempType({ commit }, data) {
      commit("SETEDITORTEMPTYPE", data);
    },
    setCurrentIpNo({ commit }, data) {
      commit("SET_CURRENT_IP_NO", data)
    },
    setPathAlias({ commit }, data) {
      commit("SET_PATH_ALIAS", data)
    },
    setUpdateNotice({ commit }, data) {
      commit("SET_UPDATE_NOTICE", data)
    },
  },
  modules: {},
  plugins: [createPersistedState({ storage: window.localStorage })],
});
